import type { ReactNode } from "react";

/** Label above a control, 12.5 px muted (FRONTEND_DESIGN.md §2.2 secondary text). */
export function Field({
  label,
  hint,
  children,
  htmlFor,
}: {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  htmlFor?: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={htmlFor} className="text-[12.5px] text-neutral-500">
        {label}
      </label>
      {children}
      {hint && <p className="text-[12px] text-neutral-500">{hint}</p>}
    </div>
  );
}
